// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EX3_byarZuUjGtVEy1si{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.EX3_byarZuUjGtVEy1si.CsTRq4CBKdpw8CHmKchi{flex-direction:column}.EX3_byarZuUjGtVEy1si.no9FAJkn7kqiaq0If4L6{flex-direction:column}.EX3_byarZuUjGtVEy1si.no9FAJkn7kqiaq0If4L6 .vSwhSsihfvXSqONMGcqk{width:100%;justify-content:space-between}.EX3_byarZuUjGtVEy1si .vSwhSsihfvXSqONMGcqk{flex-direction:row;display:flex}.EX3_byarZuUjGtVEy1si .sxNWjKZqWxhJ8zMhO7BA{flex:1;display:flex;justify-content:center;align-items:center;position:relative;width:100%;height:100%}.EX3_byarZuUjGtVEy1si .DLmI07WrBtXG9wQFHa2A{width:100%;height:100%;position:absolute;top:0;left:0;opacity:0;transition:opacity .3s ease-in-out;z-index:1}.EX3_byarZuUjGtVEy1si .DLmI07WrBtXG9wQFHa2A.Tn06u_QU750NPBc4tIEE{z-index:2;opacity:1}.EX3_byarZuUjGtVEy1si .fIqmcvLJ7qjg6Z9QTuRR{display:flex;align-items:center}.EX3_byarZuUjGtVEy1si .FRt5TP11YjCVWJdAJQUJ{width:.5rem;height:.5rem;margin:0 .25rem;border-radius:50%;background:#ecedf5;cursor:pointer}.EX3_byarZuUjGtVEy1si .FRt5TP11YjCVWJdAJQUJ:hover{background:#a079f5}.EX3_byarZuUjGtVEy1si .FRt5TP11YjCVWJdAJQUJ.Tn06u_QU750NPBc4tIEE{background:#6e32f0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `EX3_byarZuUjGtVEy1si`,
	"bottom": `CsTRq4CBKdpw8CHmKchi`,
	"bottomWide": `no9FAJkn7kqiaq0If4L6`,
	"controls": `vSwhSsihfvXSqONMGcqk`,
	"container": `sxNWjKZqWxhJ8zMhO7BA`,
	"item": `DLmI07WrBtXG9wQFHa2A`,
	"active": `Tn06u_QU750NPBc4tIEE`,
	"breadcrumbs": `fIqmcvLJ7qjg6Z9QTuRR`,
	"dot": `FRt5TP11YjCVWJdAJQUJ`
};
export default ___CSS_LOADER_EXPORT___;
